<template>
    <div class="mega-menu__panel" :class="{ active : isActive }" :aria-hidden="!isActive">
      <div class="panel-body">
        <CloseMenu @click.native="$emit('close-panel', true)" :name="name" />

        <div class="panel-lists">
          <PanelGroup
            v-for="list in lists"
            :key="list.header.name"
            :links="list.links"
            :header="list.header"
          />
        </div>
      </div>
      <Promo :promo="promo" />
    </div>
</template>
<script>
  import CloseMenu from "./CloseMenu"
  import PanelGroup from "./MenuPanelGroup"
  import Promo from "./Promo"

  export default {
    name: 'MegaMenuPanel',
    props: {
      name: String,
      isActive: Boolean,
      lists: Array,
      promo: Object,
    },
    components: {
      CloseMenu,
      PanelGroup,
      Promo
    },
    computed: {
      tabIndex() {
        return (this.isActive) ? 0 : -1
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mega-menu__panel  {
    background: #fff;
    position: absolute;
    width: 100%;
    left: 0;
    top: 60px;
    z-index: 1001;
    max-height: 0;
    visibility: hidden;
    overflow: hidden;
    transition: max-height .2s ease-in, max-height .2s ease-out;
    
    &.active {
      max-height: 1000px;
      visibility: visible;
    }

    .panel-body { 
      width: 1271px;
      margin: 0 auto;
      padding: 10px 15px 0px;
    }
  
    .panel-lists {
      width: 100%;
      column-count: 4;
      column-gap: 40px;
      padding-bottom: 20px;
    }
  }


  .slide-enter-active {
    transition-duration: 1s;
  }
  .slide-leave-active {
    transition-duration: .2s;
  }
  .slide-enter-to, .slide-leave {
    max-height: 1000px;
    overflow: hidden;
  }
  .slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
  }
</style>
